import { InertiaApp } from '@inertiajs/inertia-vue'
import Vuex from 'vuex'
import Vue from 'vue'

Vue.config.productionTip = false
Vue.mixin({ methods: { route: window.route } })
Vue.use(InertiaApp)
Vue.use(Vuex)

import VueLodash from 'vue-lodash'
import lodash from 'lodash'
Vue.use(VueLodash, { lodash: lodash })

import skeleton from 'skeleton/skeleton'
Vue.mixin(skeleton)

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

import CKEditor from "@ckeditor/ckeditor5-vue"
Vue.use(CKEditor);

import Layout from './Shared/Layout'
Vue.component('layout', Layout);

import FrontLayout from './Shared/FrontLayout'
Vue.component('front-layout', FrontLayout);

import ImageInput from './Shared/Inputs/Image'
Vue.component('image-input', ImageInput)

import ImageInputWithPreview from './Shared/Inputs/ImageWithPreview'
Vue.component('image-input-with-preview', ImageInputWithPreview)

import FileInputWithPreview from './Shared/Inputs/FileWithPreview'
Vue.component('file-input-with-preview', FileInputWithPreview)

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/index.css';
Vue.use(VueToast);

import ImageLightbox from './Shared/ImageLightbox'
Vue.component('image-lightbox', ImageLightbox)

import Treeselect from '@riophae/vue-treeselect'
Vue.component('treeselect', Treeselect);
import '@riophae/vue-treeselect/dist/vue-treeselect.min.css'

import VueFlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
Vue.use(VueFlatPickr);

import VueMask from 'v-mask'
Vue.use(VueMask);

//import '@fortawesome/fontawesome-pro/css/all.css';
import 'nprogress/nprogress.css'
import 'flag-icon-css/css/flag-icon.css'

const app = document.getElementById('app')

import Store from './store'
const store = new Vuex.Store(Store)

const query = require('query-string')
Vue.prototype.$query = query

import mixins from './mixins'
Vue.mixin(mixins)
import trans from './mixins/trans'
Vue.mixin(trans);
import templateView from './mixins/templateView'
Vue.mixin(templateView)

import moment from 'moment'
Vue.prototype.moment = moment

new Vue({
  store,
  render: h => h(InertiaApp, {
    props: {
      initialPage: JSON.parse(app.dataset.page),
      resolveComponent: name => import(`./Pages/${name}`).then(module => module.default),
    },
  }),
}).$mount(app)